/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  RainRigCommand_RainRigCommandType,
  rainRigCommand_RainRigCommandTypeFromJSON,
  rainRigCommand_RainRigCommandTypeToJSON,
} from "../../../../dock/weather_testing/weather_testing";
import { DisturbanceRequest } from "../../../../sim/simulator/disturbances";

export const protobufPackage = "skills";

export interface WeatherActionArgs {
  disturbanceRequest?: DisturbanceRequest | undefined;
  rainRequest?: RainRigCommand_RainRigCommandType | undefined;
  timeout: number;
}

export interface WeatherActionResultData {
}

export interface WeatherActionStateData {
}

function createBaseWeatherActionArgs(): WeatherActionArgs {
  return { disturbanceRequest: undefined, rainRequest: undefined, timeout: 0 };
}

export const WeatherActionArgs = {
  encode(message: WeatherActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.disturbanceRequest !== undefined) {
      DisturbanceRequest.encode(message.disturbanceRequest, writer.uint32(10).fork()).ldelim();
    }
    if (message.rainRequest !== undefined) {
      writer.uint32(16).int32(message.rainRequest);
    }
    if (message.timeout !== 0) {
      writer.uint32(29).float(message.timeout);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WeatherActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeatherActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.disturbanceRequest = DisturbanceRequest.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.rainRequest = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.timeout = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WeatherActionArgs {
    return {
      disturbanceRequest: isSet(object.disturbanceRequest)
        ? DisturbanceRequest.fromJSON(object.disturbanceRequest)
        : undefined,
      rainRequest: isSet(object.rainRequest)
        ? rainRigCommand_RainRigCommandTypeFromJSON(object.rainRequest)
        : undefined,
      timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : 0,
    };
  },

  toJSON(message: WeatherActionArgs): unknown {
    const obj: any = {};
    if (message.disturbanceRequest !== undefined) {
      obj.disturbanceRequest = DisturbanceRequest.toJSON(message.disturbanceRequest);
    }
    if (message.rainRequest !== undefined) {
      obj.rainRequest = rainRigCommand_RainRigCommandTypeToJSON(message.rainRequest);
    }
    if (message.timeout !== 0) {
      obj.timeout = message.timeout;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WeatherActionArgs>, I>>(base?: I): WeatherActionArgs {
    return WeatherActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeatherActionArgs>, I>>(object: I): WeatherActionArgs {
    const message = createBaseWeatherActionArgs();
    message.disturbanceRequest = (object.disturbanceRequest !== undefined && object.disturbanceRequest !== null)
      ? DisturbanceRequest.fromPartial(object.disturbanceRequest)
      : undefined;
    message.rainRequest = object.rainRequest ?? undefined;
    message.timeout = object.timeout ?? 0;
    return message;
  },
};

function createBaseWeatherActionResultData(): WeatherActionResultData {
  return {};
}

export const WeatherActionResultData = {
  encode(_: WeatherActionResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WeatherActionResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeatherActionResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WeatherActionResultData {
    return {};
  },

  toJSON(_: WeatherActionResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WeatherActionResultData>, I>>(base?: I): WeatherActionResultData {
    return WeatherActionResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeatherActionResultData>, I>>(_: I): WeatherActionResultData {
    const message = createBaseWeatherActionResultData();
    return message;
  },
};

function createBaseWeatherActionStateData(): WeatherActionStateData {
  return {};
}

export const WeatherActionStateData = {
  encode(_: WeatherActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WeatherActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeatherActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WeatherActionStateData {
    return {};
  },

  toJSON(_: WeatherActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WeatherActionStateData>, I>>(base?: I): WeatherActionStateData {
    return WeatherActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeatherActionStateData>, I>>(_: I): WeatherActionStateData {
    const message = createBaseWeatherActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
